/**
 * Static Tailwind class map for classification-label colors. Dynamic
 * `bg-${color}-500` gets purged by JIT, so the full set of class names
 * has to appear as string literals somewhere.
 */
const LABEL_COLOR_MAP: Record<string, string> = {
  red: 'bg-red-500',
  orange: 'bg-orange-500',
  amber: 'bg-amber-500',
  yellow: 'bg-yellow-500',
  lime: 'bg-lime-500',
  green: 'bg-green-500',
  emerald: 'bg-emerald-500',
  teal: 'bg-teal-500',
  cyan: 'bg-cyan-500',
  sky: 'bg-sky-500',
  blue: 'bg-blue-500',
  indigo: 'bg-indigo-500',
  violet: 'bg-violet-500',
  purple: 'bg-purple-500',
  fuchsia: 'bg-fuchsia-500',
  pink: 'bg-pink-500',
  rose: 'bg-rose-500',
  slate: 'bg-slate-500',
  gray: 'bg-gray-500',
  zinc: 'bg-zinc-500',
};

export function labelColorClass(color: string | null | undefined): string | undefined {
  if (!color) return undefined;
  return LABEL_COLOR_MAP[color];
}
